/************************* Custom Complimantary products in cart drawer *************************/

// Change the _cartUpdateListener to the event name that is fired when the cart is updated.
// If you are using Dawn theme, leave it as is, as it will use the pub sub event.
// If you are using a different theme, you will need to find the event name that is fired when the cart is updated.
const _cartUpdateListener = 'cart:build';
const _themeIsDawn = false;

class CartUpsell extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.dom = {};
    this.dom.container = this.querySelector('.gtc\\:upsell-container');
    this.dom.productContainer = this.querySelector('.cart-drawer__upsell__list');
    this.dom.upsellContainer = document.querySelector('.cart-drawer__upsell');

    this.settings = {
      ...JSON.parse(this.getAttribute('settings'))
    }

    this.ObserveElement();
    this.AddListeners();
  }

  disconnectedCallback() {
    this.RemoveListeners();
  }


  AnimateHeight = (element, from, to, duration) => {
    let start = null;
    const step = (timestamp) => {
      if (!start) start = timestamp;
      const progress = timestamp - start;
      const value = (progress / duration) * (to - from) + from;
      element.style.height = `${ value }px`;
      if (progress < duration) {
        window.requestAnimationFrame(step);
      } else {
        if (to !== 0) {
          element.style.height = `auto`;
        } else {
          element.style.height = `${ to }px`;
        }
      }
    };
    window.requestAnimationFrame(step);
  };

  HideContainer = (bool) => {
    if (bool) {
      this.AnimateHeight(this, this.offsetHeight, 0, 300);
    } else {
      this.AnimateHeight(this, 0, this.scrollHeight, 300);
    }
  }

  ObserveElement() {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.5 // Change this threshold value as needed
    };

    this.observer = new IntersectionObserver((entries, observer) => {

      entries.forEach(async entry => {
        if (entry.isIntersecting) {
          if (this.settings.intent !== 'manual') {
            await this.GetUpsellProducts({ cart: null });
          }
          else if (this.settings.intent === 'manual' && this.dom.productContainer.children.length > 0) {
            this.dom.container.hidden = false;
            this.HideContainer(false)
            requestAnimationFrame(() => {
              this.dom.upsellContainer.classList.add('cart-drawer--open')
            });
          }
          // Stop observing intersection of target
          this.observer.disconnect();
        }
      });
    }, options);

    this.observer.observe(this);
  }

  AddListeners() {
    this.addEventListener('click', this.HandleClick);

    document.addEventListener('cart:updated', async () => {
      if (this.settings.intent !== 'manual'){
        await this.GetUpsellProducts({ cart: null });
      }
    });
  }

  RemoveListeners() {

    if (this.observer) {
      this.observer.disconnect();
    }

    this.removeEventListener('click', this.HandleClick);

    if (this.settings.intent !== 'manual') return;
    document.removeEventListener('cart:change', async (event) => {
      await this.GetUpsellProducts({ cart: event.detail.cart });
    });
  }

  CompareArrays = (a, b) => {
    return JSON.stringify(a) === JSON.stringify(b);
  };

  GetUpsellProducts = async ({ cart }) => {

    if (!this.dom.container || !this.dom.productContainer) return;
    const url = this.settings.url;
    const limit = Number(this.settings.limit)
    const urls = [];
    let productsArr = [];

    if (cart === null) {
      cart = await (await fetch(`${ Shopify.routes.root }cart.js`)).json();
    }

    const products_id = cart.items.map((x) => x.product_id);

    if (products_id.length < 0 || products_id.length === 0) {
      return;
  }

    //If there is no change in the products, abort.
    if (this.CompareArrays(this.settings.cartProductIdArray, products_id)) return;

    //Save the products currently in cart.
    this.settings.cartProductIdArray = products_id


    /**
    * Reversing the array, so the first product added complimentary products get shown first
    */
    products_id.reverse();

    products_id.forEach((id) => {
      urls.push(url.replace('[product_id]', id));
    });

    let productCount = 0;

    // Getting array of complementary products
    await Promise.all(
      urls.map((url) =>
        fetch(url)
          .then((response) => response.json())
          .then((json) => {
            json.products.forEach(product => {
              if (limit === 0 || productCount < limit) {
                productsArr.push(product);
                productCount++;
              } else {
                return
              }
            });
          })
          .catch((e) => {
            console.error(e);
          })
      )
    );

    // Uniqify array of complementary products
    const uniqueProductsArr = Array.from(
      new Set(productsArr.map((a) => a.id))
    ).map((id) => {
      return productsArr.find((a) => a.id === id);
    });

    if (productsArr.length <= 0) {
      this.HideContainer(true)
      this.dom.container.hidden = true;
      this.dom.upsellContainer.classList.remove('cart-drawer--open')
      return;
    }


    let upsellProductObjArray = [];

    // Getting html for array of complementary products
    await Promise.all(
      uniqueProductsArr.map((product) =>
        fetch(`/products/${ product.handle }?view=cart-upsell`)
          .then((data) => {
            return data.text();
          })
          .then((htmlText) => {

            const upsellProductObj = {};
            upsellProductObj.id = product.id;
            upsellProductObj.html = htmlText;
            upsellProductObjArray.push(upsellProductObj);
          })
      )
    );

    const uniqueProductsIdArr = uniqueProductsArr.map(product => product.id);

    upsellProductObjArray.sort(function(a, b) {
      return uniqueProductsIdArr.indexOf(a.id) - uniqueProductsIdArr.indexOf(b.id);
    });

    let newProductsString = '';
    upsellProductObjArray.forEach(upsellProductObj => {
      newProductsString += upsellProductObj.html;
    });

    this.dom.productContainer.innerHTML = null;
    this.dom.productContainer.insertAdjacentHTML('beforeend', newProductsString);
    this.dom.container.hidden = false;
    this.HideContainer(false);
    requestAnimationFrame(() => {
      this.dom.upsellContainer.classList.add('cart-drawer--open')
    });
  };

  ButtonLoading = (button, bool) => {
    if (bool) {
      button.disabled = true;
      button.classList.add('loading');
    } else {
      button.disabled = false;
      button.classList.remove('loading');
    }
  }


  RemoveItem = (item) => {
    item.classList.add('gtc:upsell-item--removed');
    if (this.dom.productContainer.children.length <= 1) {
      setTimeout(() => {

        this.dom.upsellContainer.classList.remove('cart-drawer--open')

        // Add an event listener for the transition end
        this.dom.upsellContainer.addEventListener('transitionend', (event) => {
          this.dom.container.hidden = true;
        }, { once: true }); // The { once: true } option ensures the event listener is removed after it is triggered

      }, 500);

    }
    else {
      setTimeout(() => {
        item.remove();
      }, 500);
    }
  }

  HandleClick(e) {
    const target = e.target;

    if (target.dataset.variantId !== undefined) {
      const upsellItem = target.closest('.gtc\\:upsell-item');
      const button = target;
      const variantId = target.dataset.variantId;
      const quantity = 1;

      this.ButtonLoading(button, true);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            quantity: quantity,
            id: variantId
          }]
        })
      })
        .then((response) => response.json())
        .then((data) => {
          (async () => {
            const cartObject = await this.GetCart();
            this.ButtonLoading(button, false);
            this.RemoveItem(upsellItem);

            if (_themeIsDawn) {
              publish(PUB_SUB_EVENTS.cartUpdate, {});
            }
            else {
              document.dispatchEvent(new CustomEvent(_cartUpdateListener, {
                detail: {
                  cart: cartObject
                }
              }));
            }
          })();

        })
        .catch((error) => {
          this.ButtonLoading(button, false);
          console.error('Error:', error);
        });
    }
  }

  GetCart = async () => {
    const cart = await (await fetch(`${ Shopify.routes.root }cart.js`)).json();
    return cart;
  };

}
customElements.define('gtc-cart-upsell', CartUpsell);